import React from 'react';

import {AuthorizationsUnifiedList} from 'presentation/pages/private/authorizations/pages';

export const MakeAuthorizationsList: React.FC = () => <AuthorizationsUnifiedList />;
